module.exports = __webpack_public_path__ + "static/media/offline.f4547ad0.svg";